import { Button, InputNumber } from 'antd';
import { BorderOuterOutlined } from '@ant-design/icons';
import LabelledRow from '../LabelledRow';
import BoxColorField from './BoxColorField';
import FieldGroupLabel from './FieldGroupLabel';
import { borderIcons } from '../../../constants/constants';
import { DEFAULT_BORDER } from '../../../shared/boxes/borderStyles';
import { cssLengthToPx, pxToRemCss } from '../../../shared/boxes/cssLength';

const SIDES = [
  { key: 'top', label: 'Haut' },
  { key: 'bottom', label: 'Bas' },
  { key: 'left', label: 'Gauche' },
  { key: 'right', label: 'Droite' },
];

const NUMBER_WIDTH = 72;

/**
 * Bordures d'une box partagée : quatre côtés, une couleur, un rayon — le
 * format du bloc web, recopié tel quel par le parser. Le trait fait 1 px comme
 * sur le site (cf. docs/webviewer/chantier-boxes-partagees.md §2).
 *
 * Servi à l'identique dans le configurateur du template et dans le panel de
 * droite d'une box.
 */
const BoxBorderFields = ({
  border: value, locked, labelOfColor, colorOfLabel, onChange,
}) => {
  const border = { ...DEFAULT_BORDER, ...(value || {}) };
  const setBorderProp = (key, next) => onChange({ ...border, [key]: next });

  return (
    <>
      <FieldGroupLabel>Bordures</FieldGroupLabel>
      <LabelledRow label="Couleur">
        <BoxColorField
          label="Couleur des bordures"
          icon="border-outer"
          disabled={locked}
          value={labelOfColor(border.color)}
          onChange={(label) => setBorderProp('color', colorOfLabel(label))}
        />
      </LabelledRow>
      {/* Mêmes boutons de côté que partout ailleurs dans les réglages du
          proposal (cf. textTab) plutôt que des cases à cocher. */}
      <LabelledRow label="Côtés affichés" stacked>
        {SIDES.map(({ key, label }) => (
          <Button
            key={key}
            title={label}
            disabled={locked}
            className={`RichEditor-styleButton${border[key] ? '  RichEditor-activeButton' : ''}`}
            icon={borderIcons[key]}
            onClick={() => setBorderProp(key, !border[key])}
          />
        ))}
        <Button
          title="Toutes"
          disabled={locked}
          className={`RichEditor-styleButton${
            SIDES.every(({ key }) => border[key]) ? '  RichEditor-activeButton' : ''
          }`}
          icon={<BorderOuterOutlined />}
          onClick={() => onChange({
            ...border, top: true, bottom: true, left: true, right: true,
          })}
        />
      </LabelledRow>
      <LabelledRow label="Arrondi des angles">
        {/* px saisis, rem stockés : la box part aussi sur le site, qui est
            responsive (README webviewer §4). */}
        <InputNumber
          size="small"
          min={0}
          max={64}
          disabled={locked}
          style={{ width: NUMBER_WIDTH }}
          value={cssLengthToPx(border.radius) ?? 0}
          onChange={(px) => setBorderProp('radius', pxToRemCss(px))}
        />
      </LabelledRow>
    </>
  );
};

export default BoxBorderFields;
